module.exports = __webpack_public_path__ + "static/media/ic_nosmoke.126f3400.png";